/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";

const RichTextWithImage = (props) => {

    const richtext = props?.richtext;
    const image = props?.image; //image is an image object with a url property
    const side = props?.side ?? "left";
    const displayWidth = props?.displayWidth;
    const displayHeight = props?.displayHeight;
    const orientation = props?.orientation;
    const imageSettings = props?.imageSettings ?? [];

    const options = imageSettings?.options ?? [];
    const useCaption = options?.useCaption;
    const caption = image?.description;

    const classlist = `simplicity-richtext-wrap-image ${side} ${orientation}`;

    return (
        <div className='rich-text-display read-only'>
            {image &&
                <div
                    style={{
                        width: displayWidth,
                        height: displayHeight,
                    }}
                    className={classlist}
                >
                    <img
                        src={image.url}
                        alt={image?.alt || "SimpliCity image"}
                    />
                    {useCaption && caption &&
                        <div className={"simplicity-image-caption"}>
                            {caption}
                        </div>
                    }
                </div>
            }
            <RichTextPreview richtext={richtext} />
        </div>
    );
};

export { RichTextWithImage };
